import { defineStore } from 'pinia'
import { useTemplateStore } from './template'

export const useFavoriteLinksStore = defineStore('favoriteLinks', {
  state: () => ({
    localLinks: {},
    isLoading: false
  }),

  getters: {
    getLinksForSite: () => siteId => {
      const savedLinks = useFavoriteLinksStore().getSavedLinksForSite(siteId)
      const autoLinks = useFavoriteLinksStore().getAutomaticLinks(siteId)

      const manualLinks = savedLinks.filter(link => !link.isAutomatic)
      const allLinks = [...autoLinks, ...manualLinks]

      return allLinks
    },

    getSavedLinksForSite: state => siteId => {
      const templateStore = useTemplateStore()

      if (templateStore.config && templateStore.config.favorite_links) {
        if (
          templateStore.config.favorite_links.favorite_links &&
          templateStore.config.favorite_links.favorite_links[siteId]
        ) {
          return templateStore.config.favorite_links.favorite_links[siteId]
        }

        if (templateStore.config.favorite_links[siteId]) {
          return templateStore.config.favorite_links[siteId]
        }

        if (Array.isArray(templateStore.config.favorite_links)) {
          return templateStore.config.favorite_links
        }
      }

      return state.localLinks[siteId] || []
    },

    getAutomaticLinks: () => () => {
      const templateStore = useTemplateStore()
      if (!templateStore.config) return []

      const config = templateStore.config
      const autoLinks = []

      if (config.networkId) {
        autoLinks.push({
          title: 'Google Ad Manager',
          url: `https://admanager.google.com/${config.networkId}`,
          isAutomatic: true
        })
      }

      if (config.sheetAdx) {
        autoLinks.push({
          title: 'Planilha ADX',
          url: `https://docs.google.com/spreadsheets/d/${config.sheetAdx}`,
          isAutomatic: true
        })
      }

      if (config.sheetMediaBuy) {
        autoLinks.push({
          title: 'Planilha Media Buy',
          url: `https://docs.google.com/spreadsheets/d/${config.sheetMediaBuy}`,
          isAutomatic: true
        })
      }

      return autoLinks
    },

    hasSavedLinks: state => siteId => {
      const allLinks = state.getLinksForSite(siteId)
      return allLinks && allLinks.length > 0
    }
  },

  actions: {
    initFromConfig() {
      const templateStore = useTemplateStore()
      if (!templateStore.config) return

      if (!templateStore.config.favorite_links) {
        this.updateConfigLinks(templateStore.site, [])
      }
    },

    async updateConfigLinks(siteId, linksData) {
      this.isLoading = true

      try {
        const templateStore = useTemplateStore()

        const manualLinks = linksData.filter(link => !link.isAutomatic)

        const cleanUpdate = { favorite_links: manualLinks }

        await templateStore.updateConfig(siteId, cleanUpdate)

        if (this.localLinks[siteId]) {
          delete this.localLinks[siteId]
        }

        await templateStore.fetchConfig(siteId)

        return true
      } catch (error) {
        console.error('Erro ao atualizar links favoritos:', error)
        return false
      } finally {
        this.isLoading = false
      }
    },

    async addLink(siteId, link) {
      const currentLinks = [...this.getLinksForSite(siteId)]

      const exists = currentLinks.some(item => item.url === link.url)
      if (!exists) {
        currentLinks.push(link)

        return this.updateConfigLinks(siteId, currentLinks)
      }

      return true
    },

    async removeLink(siteId, linkIndex) {
      const currentLinks = [...this.getLinksForSite(siteId)]

      if (currentLinks.length > linkIndex) {
        if (currentLinks[linkIndex].isAutomatic) {
          console.warn('Tentativa de remover um link automático foi ignorada')
          return true
        }
        const manualLinks = currentLinks.filter(
          (link, idx) => !link.isAutomatic && idx !== linkIndex
        )

        return this.updateConfigLinks(siteId, manualLinks)
      }

      return false
    },

    async editLink(siteId, linkIndex, updatedLink) {
      const currentLinks = [...this.getLinksForSite(siteId)]

      if (currentLinks.length > linkIndex) {
        if (currentLinks[linkIndex].isAutomatic) {
          console.warn('Tentativa de editar um link automático foi ignorada')
          return true
        }
        const updatedLinks = currentLinks
          .map((link, idx) => {
            if (!link.isAutomatic && idx === linkIndex) {
              return { ...updatedLink, isAutomatic: false }
            }
            return link
          })
          .filter(link => !link.isAutomatic)

        return this.updateConfigLinks(siteId, updatedLinks)
      }

      return false
    }
  }
})
